import React, { useState, useEffect } from 'react';
import { getOrders, getSites, getProducts, getPacks } from '../api';

export default function DashboardPage() {
  const [orders, setOrders] = useState([]);
  const [sites, setSites] = useState([]);
  const [products, setProducts] = useState([]);
  const [packs, setPacks] = useState([]);

  useEffect(() => {
    Promise.all([getOrders(), getSites(), getProducts(), getPacks()])
      .then(([o, s, p, pk]) => {
        setOrders(o.data);
        setSites(s.data);
        setProducts(p.data);
        setPacks(pk.data);
      })
      .catch(console.error);
  }, []);

  const draftOrders = orders.filter(o => o.Status === 'Draft').length;
  const pendingOrders = orders.filter(o => ['StockCheck', 'Substitution', 'Pending'].includes(o.Status)).length;
  const submittedOrders = orders.filter(o => o.Status === 'Submitted').length;

  return (
    <>
      <div className="top-header">
        <h1>Dashboard</h1>
        <div className="top-header-actions">
          <span className="text-muted text-sm">Orders HubSpot Portal</span>
        </div>
      </div>
      <div className="page-content">
        <div className="stats-row">
          <div className="stat-card">
            <div className="stat-value">{orders.length}</div>
            <div className="stat-label">Total Orders</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{draftOrders}</div>
            <div className="stat-label">Draft</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{pendingOrders}</div>
            <div className="stat-label">In Progress</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{submittedOrders}</div>
            <div className="stat-label">Submitted</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{products.length}</div>
            <div className="stat-label">Products</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{packs.length}</div>
            <div className="stat-label">Packs</div>
          </div>
        </div>

        <div className="hs-card mb-lg">
          <div className="hs-card-header">
            <h2>Recent Orders</h2>
          </div>
          <table className="hs-table">
            <thead>
              <tr>
                <th>Order #</th>
                <th>Customer</th>
                <th>Site</th>
                <th>Status</th>
                <th>Lines</th>
                <th className="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr><td colSpan="6" className="text-center text-muted" style={{padding: '40px'}}>No orders yet. Create your first order!</td></tr>
              ) : (
                orders.slice(0, 5).map(order => (
                  <tr key={order.OrderId} className="clickable" onClick={() => window.location.href = `/orders/${order.OrderId}`}>
                    <td><strong>{order.OrderNumber}</strong></td>
                    <td>{order.CustomerName}</td>
                    <td>{order.Site?.SiteName || '—'}</td>
                    <td><span className={`hs-badge hs-badge-${order.Status.toLowerCase()}`}>{order.Status}</span></td>
                    <td>{order.LineCount}</td>
                    <td className="text-right font-mono">£{order.TotalAmount?.toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="hs-card">
          <div className="hs-card-header">
            <h2>Franchise Sites</h2>
          </div>
          <table className="hs-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Region</th>
              </tr>
            </thead>
            <tbody>
              {sites.map(site => (
                <tr key={site.SiteId}>
                  <td><code className="font-mono">{site.SiteCode}</code></td>
                  <td>{site.SiteName}</td>
                  <td>{site.Region}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
